import { create } from "zustand";

type State = {
  listId: string | null;
  request: (listId: string) => void;
  clear: () => void;
};

export const useNewTaskFocus = create<State>((set) => ({
  listId: null,
  request: (listId) => set({ listId }),
  clear: () => set({ listId: null }),
}));
